import { render } from "./ItemViewer.vue?vue&type=template&id=2292e5d8"
import script from "./ItemViewer.vue?vue&type=script&lang=js"
export * from "./ItemViewer.vue?vue&type=script&lang=js"

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__